import { ModuleHtmlNode } from './createModuleHtmlNode';

/**
 * markdown-module：markdown/markdown-name 解析后展开的 HTML 内容模块。
 * 用 contentEditable + innerHTML 渲染 HTML 表格（对齐 V1 markdown-module/render.ts）。
 * 实现细节见 createModuleHtmlNode.tsx。
 */
export const MarkdownModuleNode = ModuleHtmlNode.createModuleNode(
  'markdown-module',
  'MarkdownModuleNode',
);
